import { TRANALATIONJOB_LIST } from "./types";

export const translationJobList = (data, onSuccess, onError) => {
    return {
        type: TRANALATIONJOB_LIST,
        data,
        onSuccess,
        onError,
    };
};

